/**
 * Centralized Icon & Color Library for all HTML UIs
 */

export const ICONS = {
  elements: { physical: '⚔️', od: '🔥', su: '❄️', gok: '⚡', karanlik: '💀' },
  slots: { head: '🪖', chest: '🛡️', gloves: '🧤', boots: '👢', belt: '⛓️', weapon: '⚔️', offhand: '🛡️', amulet: '📿', ring1: '💍', ring2: '💍', cape: '🧣' },
  nodes: { small: '●', notable: '◆', keystone: '★', attribute: '◉', branch_start: '⬟', center: '✦' },
  branches: { demir: '⚔️', kale: '🏰', avci: '🏹', golge: '🗡️', firtina: '🌩️', ruhlar: '👻' },
  stats: { strength: '💪', agility: '🦅', spirit: '🔮', hp: '❤️', mana: '💧', armor: '🛡️', evasion: '💨', energyShield: '🔷', critChance: '🎯', critDamage: '💥', attackSpeed: '⚡', castSpeed: '🌀', moveSpeed: '🏃', lifeLeech: '🩸', manaLeech: '💜' },
  skills: { melee: '⚔️', projectile: '🏹', aoe: '💥', beam: '⚡', aura: '🔵', buff: '📣', trap: '🪤', totem: '🗿', curse: '☠️', minion: '👻' },
  ui: { close: '✕', add: '+', remove: '✕', save: '💾', load: '📂', export: '📤', import: '📥', delete: '🗑️', edit: '✏️', settings: '⚙️', back: '←', gold: '🪙', place: '✚', connect: '🔗', move: '✋', undo: '↩️', search: '🔍' },
  rarities: { normal: '⬜', magic: '🔵', rare: '🟡', set: '🟢', legendary: '🟠' },
  ailments: { bleed: '🩸', burn: '🔥', poison: '☠️', chill: '❄️', freeze: '🧊', shock: '⚡' },
  currency: { ruh_tozu: '✨', tengri_ozu: '🌟', erlik_tasi: '💎', arindirma_suyu: '💧', ruh_muhru: '🔮', yikim_tozu: '💀', tamga_muhru: '🔱', tengri_duasi: '🙏' },
};

export const BRANCH_COLORS: Record<string, string> = {
  demir: '#b87333', kale: '#708090', avci: '#228b22', golge: '#6a0dad', firtina: '#3498db', ruhlar: '#8e44ad', '': '#555555',
};

export const NODE_SIZES: Record<string, number> = {
  small: 10, notable: 16, keystone: 22, attribute: 12, branch_start: 18, center: 24,
};

export const NODE_TYPE_COLORS: Record<string, string> = {
  small: '#8a8a6a', notable: '#4a9eff', keystone: '#ff4444', attribute: '#ffd700', branch_start: '#ffd700', center: '#ffffff',
};

export const STAT_OPTIONS: { value: string; label: string; icon: string }[] = [
  // Flat stats
  { value: 'flatHp', label: 'Düz Can', icon: '❤️' },
  { value: 'flatMana', label: 'Düz Mana', icon: '💧' },
  { value: 'flatArmor', label: 'Düz Zırh', icon: '🛡️' },
  { value: 'flatEvasion', label: 'Düz Kaçınma', icon: '💨' },
  { value: 'flatStrength', label: 'Düz Güç', icon: '💪' },
  { value: 'flatAgility', label: 'Düz Çeviklik', icon: '🦅' },
  { value: 'flatSpirit', label: 'Düz Ruh', icon: '🔮' },
  // Percent stats
  { value: 'percentHp', label: '% Can', icon: '❤️' },
  { value: 'percentMana', label: '% Mana', icon: '💧' },
  { value: 'percentDamage', label: '% Hasar', icon: '⚔️' },
  { value: 'percentPhysicalDamage', label: '% Fiziksel Hasar', icon: '⚔️' },
  { value: 'percentElementalDamage', label: '% Elemental Hasar', icon: '🌈' },
  { value: 'percentFireDamage', label: '% Ateş Hasarı', icon: '🔥' },
  { value: 'percentLightningDamage', label: '% Yıldırım Hasarı', icon: '⚡' },
  { value: 'percentColdDamage', label: '% Buz Hasarı', icon: '❄️' },
  { value: 'percentDarkDamage', label: '% Karanlık Hasarı', icon: '💀' },
  { value: 'percentSpellDamage', label: '% Büyü Hasarı', icon: '🔮' },
  { value: 'percentAttackSpeed', label: '% Saldırı Hızı', icon: '⚡' },
  { value: 'percentCastSpeed', label: '% Büyü Hızı', icon: '🌀' },
  { value: 'percentMovementSpeed', label: '% Hareket Hızı', icon: '🏃' },
  { value: 'percentCritChance', label: '% Kritik Şansı', icon: '🎯' },
  { value: 'percentCritDamage', label: '% Kritik Hasarı', icon: '💥' },
  { value: 'percentArmor', label: '% Zırh', icon: '🛡️' },
  { value: 'percentEvasion', label: '% Kaçınma', icon: '💨' },
  { value: 'percentEnergyShield', label: '% Enerji Kalkanı', icon: '🔷' },
  { value: 'percentManaRegen', label: '% Mana Yenileme', icon: '💙' },
  { value: 'percentHpRegen', label: '% Can Yenileme', icon: '💚' },
  { value: 'percentCooldownReduction', label: '% Bekleme Azaltma', icon: '⏱️' },
  // Other numeric stats
  { value: 'extraDodgeCharges', label: 'Ekstra Dodge', icon: '💨' },
  { value: 'lifeLeechPercent', label: '% Can Emme', icon: '🩸' },
  { value: 'manaLeechPercent', label: '% Mana Emme', icon: '💜' },
  { value: 'projectileCount', label: 'Mermi Sayısı', icon: '🏹' },
  { value: 'areaOfEffect', label: 'Alan Etkisi', icon: '💥' },
  { value: 'dotDamage', label: 'DoT Hasarı', icon: '☠️' },
  { value: 'minionDamage', label: 'Minyon Hasarı', icon: '👻' },
  { value: 'minionLife', label: 'Minyon Canı', icon: '👻' },
  { value: 'lifeOnKill', label: 'Öldürmede Can', icon: '❤️' },
  { value: 'manaOnKill', label: 'Öldürmede Mana', icon: '💧' },
  { value: 'maxTotem', label: 'Maks Totem', icon: '🗿' },
  // Note: allResist not in PassiveBonuses but kept for potential future use
];
